module.exports = __webpack_public_path__ + "img/7725268.png";